export async function fetchViatorProducts({ ids = [] }) {
  console.log(`Fetching Viator products: ${ids}`);
  try {
    let products = [];

    for await (let id of ids.split(",")) {
      const response = await fetch(
        `${process.env.VIATOR_API_URL}/partner/products/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Accept: "application/json;version=2.0",
            "Accept-Language": "en",
            "exp-api-key": process.env.VIATOR_API_KEY,
          },
        }
      );

      const data = await response.json();
      products.push(data);
    }
    return products;
  } catch (error) {
    console.error(error);
    return { error };
  }
}
